import { render } from "./SponsorAssetsTable.vue?vue&type=template&id=69ad3076&scoped=true"
import script from "./SponsorAssetsTable.vue?vue&type=script&lang=js"
export * from "./SponsorAssetsTable.vue?vue&type=script&lang=js"

import "./SponsorAssetsTable.vue?vue&type=style&index=0&id=69ad3076&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ad3076"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTd,QImg,QIcon});
